(() => {
  angular
    .module('app.settings')
    .controller('DcmModalController', DcmModal);

  DcmModal.$inject = [
    '$q',
    '$scope',
    '$interval',
    'close',
    'provider',
    'integrations',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function DcmModal(
    $q,
    $scope,
    $interval,
    close,
    provider,
    integrations,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;

    /* ************************************************************* */
    /* **************************** Tabs *************************** */
    /* ************************************************************* */
    const tabAction = {};

    vm.tabs = [{
      id: 'connect',
      label: 'Connect',
    }, {
      id: 'advertiser',
      label: 'Advertiser',
    }, {
      id: 'granularity',
      label: 'Granularity',
    }, {
      id: 'video',
      label: 'Video ADS',
    }, {
      id: 'quality',
      label: 'Quality',
    }, {
      id: 'complete',
      label: 'Complete',
    }];

    vm.tabActive = -1;
    vm.isTabActive = id => id === vm.tabActive;
    vm.onTabSelect = id => {
      vm.tabActive = id;
      vm.tabs = vm.tabs.map(item => item.id === id ? { ...item, enable: true } : item);

      if (tabAction[id]) {
        tabAction[id]();
      }
    };

    vm.hasTabError = id => {
      const tab = vm.tabs.find(item => item.id === id);

      if (tab.done) {
        if (id === 'connect' && vm.integrationExistsError) {
          return true;
        }

        if (id === 'advertiser' && !vm.clientsAvailable) {
          return true;
        }
      }

      return false;
    };

    /* ************************************************************* */
    /* ************************** Connect ************************** */
    /* ************************************************************* */
    vm.onConnect = () => {
      vm.isProcessBusy = true;

      provider.oauth().then(({ data }) => {
        const dcm = window.open(data.url, '_blank');
        const interval = $interval(() => {
          if (!dcm || !dcm.window) {
            $interval.cancel(interval);

            $q.all([
              provider.fetchAccounts({ integrationId: data.id }),
              provider.fetchIntegration({ integrationId: data.id }),
            ])
            .then(response => {
              vm.accounts = response[0].data;
              vm.integration = response[1].data;

              vm.onStart();
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              vm.isProcessBusy = false;
            });
          }
        }, 1000);
      });
    };

    const checkAccountUsage = () => {
      vm.isProcessBusy = true;

      const { id: integrationId } = vm.integration;
      const {
        id: googleAccountId,
        profileId: googleProfileId,
      } = vm.selectedAccount;

      provider.updateIntegration({
        integrationId,
        googleAccountId,
        googleProfileId,
      })
      .then(() => {
        vm.integrationExistsError = false;
      })
      .catch(error => {
        if (error.status === 400) {
          vm.integrationExistsError = error.data.errorMessage;
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onSelectAccount = account => {
      vm.selectedAccount = {
        ...account,
        label: `${account.name} (${account.profileName})`,
      };
      vm.clients = [];

      if (!vm.title) {
        vm.title = `${vm.selectedAccount.name} (${vm.selectedAccount.profileName})`;
      }

      checkAccountUsage();
    };



    /* ************************************************************* */
    /* ************************* Advertiser ************************ */
    /* ************************************************************* */
    tabAction['advertiser'] = () => {
      if (vm.clients.length === 0 && !vm.clientsInLoading) {
        vm.loadClients();
      }
    }

    vm.clients = [];
    vm.clientsMenu = [];
    vm.clientsAvailable = true;
    vm.search = '';

    function onLoadClients() {
      vm.clientsMenu = [{
        id: 'all',
        label: `All clients (${vm.clients.length})`,
      }, {
        id: 'selected',
        label: 'Selected clients only',
      }];
      vm.selectedClients = vm.clientsMenu[0];

      const { country } = vm.integration;
      vm.selectedCountry = vm.countries.find(item => item.code === (country || 'DK'));
    }

    vm.loadClients = () => {
      vm.isProcessBusy = true;
      vm.clientsInLoading = true;
      const { id: integrationId } = vm.integration;
      const {
        id: googleAccountId,
        profileId: googleProfileId,
      } = vm.selectedAccount;

      provider.fetchClients({
        integrationId,
        googleAccountId,
        googleProfileId,
      })
        .then(({ data }) => {
          vm.clients = data || [];
        })
        .catch(error => {
          console.error(error.statusText);
        })
        .finally(() => {
          vm.isProcessBusy = false;
          vm.clientsInLoading = false;

          onLoadClients();
        });
    };

    const getAdvertiserIds = () => (
      vm.selectedClients.id !== 'all' ?
        vm.clients.filter(item => item.isSelected).map(item => item.id) :
        vm.clients.map(item => item.id)
    );

    const onEditClients = () => {
      vm.clientsAvailable = getAdvertiserIds().length !== 0;
    };

    const checkAdvertisersUsage = () => {
      vm.isProcessBusy = true;

      const { id: integrationId } = vm.integration;
      const {
        id: googleAccountId,
        profileId: googleProfileId,
      } = vm.selectedAccount;
      const { code: country } = vm.selectedCountry;

      provider.updateIntegration({
        country,
        integrationId,
        googleAccountId,
        googleProfileId,
        googleAdvertiserIds: getAdvertiserIds(),
      })
      .then(() => {
        vm.clientsAlreadyUsed = false;

        onEditClients();
      })
      .catch(error => {
        console.error(error);
        if (error.status === 400) {
          const message = /\[(.*?)\]/.exec(error.data.errorMessage);
          const ids = message ? message[1].split(',') : [];
          const clients = vm.clients.filter(({ id }) => ids.includes(id.toString()));

          vm.clientsAlreadyUsed = clients.map(({ name }) => name);
          vm.clientsAvailable = false;
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onSelectAllClients = select => {
      angular.forEach(vm.clients, client => client.isSelected = !!select);
      onEditClients();
    };

    vm.onCheckClient = client => {
      client.isSelected = !client.isSelected;
      onEditClients();
    };

    vm.onSelectClients = item => {
      vm.selectedClients = item;
      if (item.id === 'all') {
        vm.onSelectAllClients(true);
      } else {
        onEditClients();
      }
    };

    vm.onShowSearch = () => vm.searchVisible = !vm.searchVisible;
    vm.onClearSearch = () => {
      vm.searchVisible = false;
      vm.search = '';
    };



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
    vm.onSelectCountry = country => vm.selectedCountry = country;



    /* ************************************************************* */
    /* ************************* Granularity *********************** */
    /* ************************************************************* */
    tabAction['granularity'] = () => {
      if (!vm.isProcessBusy) {
        checkAdvertisersUsage();
      }
    }

    vm.granularity = [
      'Placement',
      'Site',
    ];
    vm.selectedGranularity = vm.granularity[0];
    vm.onSelectGranularity = granularity => vm.selectedGranularity = granularity;

    vm.applicationTag = [{
      key: 'Automatically',
      label: 'Measure all campaigns / ads',
    }, {
      key: 'Manually',
      label: 'Apply tag manually',
    }];
    vm.selectedApplicationTag = vm.applicationTag[0];
    vm.onSelectApplicationTag = tag => vm.selectedApplicationTag = tag;
    vm.isApplicationTagManually = () => vm.selectedApplicationTag.key !== vm.applicationTag[0].key;



    /* ************************************************************* */
    /* ************************** Video ADS ************************ */
    /* ************************************************************* */
    vm.onCheckVideoFunnel = () => {
      vm.videoFunnelChecked = !vm.videoFunnelChecked;
    };



    /* ************************************************************* */
    /* *************************** Quality ************************* */
    /* ************************************************************* */
    tabAction['quality'] = () => {
      const isSelected = key => {
        const { qualityMetrics } = vm.integration;
        return qualityMetrics && qualityMetrics.includes(key);
      };

      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: isSelected(item.key),
      }));
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
    };



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onStart = () => vm.tabActive = 'connect';
    vm.onFinish = () => close(true, 0);
    vm.onClose = () => {
      close(false, 0);
    };

    vm.onBack = id => vm.onTabSelect(id);
    vm.onNext = id => {
      vm.tabs = vm.tabs.map(item => (
        item.id === vm.tabActive ? {
          ...item,
          enable: true,
          done: true,
        } : item
      ));
      vm.onTabSelect(id);

      if (tabAction[id]) {
        tabAction[id]();
      }
    };

    vm.onEnable = () => {
      vm.isProcessBusy = true;

      const { id: integrationId } = vm.integration;
      const {
        id: googleAccountId,
        profileId: googleProfileId,
      } = vm.selectedAccount;
      const { code: country } = vm.selectedCountry;

      provider.updateIntegration({
        title: vm.title,
        country,
        integrationId,
        googleAccountId,
        googleProfileId,
        googleAdvertiserIds: getAdvertiserIds(),
        trackingLevel: vm.isApplicationTagManually() ? undefined : vm.selectedGranularity,
        tagApplication: vm.selectedApplicationTag.key,
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
        allowVideoFunnel: vm.videoFunnelChecked,
      })
      .then(() => {
        provider.activateIntegration({ integrationId })
          .then(() => {
            vm.onFinish();
          })
          .finally(() => {
            vm.isProcessBusy = false;
          });
      });
    };
  }
})();
